import React, { useContext } from 'react';
import styled from 'styled-components';
import { LocalContext } from 'context';
import Add from 'assets/svgs/add.svg';
import AddToCalendar from 'react-add-to-calendar';

const DateButton = () => {
  const { theme } = useContext(LocalContext);
  const event = {
    title: 'Retina 2021 - Virtual Event',
    description:
      'The Fighting Blindness Retina 2021 virtual conference brings together top international and Irish researchers and clinicians to showcase the latest updates on therapeutic interventions, eye care practices and scientific discovery.',
    location: 'Virtual Event',
    startTime: '2021-11-05T09:30:00.1440844',
    endTime: '2021-11-06T16:00:00.1440844'
  };
  return (
    <StyledDateButton theme={theme} width="250px">
      <AddIcon />
      <AddToCalendar event={event} buttonLabel="Add To Calendar" />
    </StyledDateButton>
  );
};

const StyledDateButton = styled.div`
  display: flex;
  height: 3rem;
  align-items: center;
  position: relative;
  z-index: 2;
  a {
    font-size: 1rem;
    margin: 0.5rem 0;
    font-weight: 700;
    font-family: 'Helvetica Neue';
    text-transform: uppercase;
    color: ${({ theme }) => (theme.className === 'contrast' ? 'yellow' : theme.fg)};
    background-color: transparent;
    cursor: pointer;
    transition: 0.5s;
    width: ${(props) => (props.width ? props.width : '100%')};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    list-style: none;
    background: ${({ theme }) => theme.bgLight};
  }
  svg {
    circle {
      fill: ${({ theme }) => (theme.className === 'contrast' ? 'yellow' : theme.fg)};
    }
    path {
      stroke: ${({ theme }) => theme.bgLight};
    }
  }
  .react-add-to-calendar {
    position: absolute;
    top: 0;
    left: 40px;
    &__button {
      height: 3rem;
      background: transparent;
      margin: 0;
      padding-left:40px;
      margin-left:-40px;
    }
    &__dropdown {
      box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.25);
      ul {
        list-style: none;
        li {
          a {
            transition: 0.5s;
            margin: 0;
            padding: 1rem;
            border-bottom: 1px solid #c4c4c4;
            color: ${({ theme }) => theme.textColor};
            animation: slideDown 0.5s ease-in forwards;
          }
        }
      }
    }
  }

  @keyframes slideDown {
    0% {
      transform: translateY(-10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
`;

const AddIcon = styled(Add)`
  width: 1.5rem;
  height: 3rem;
  position: absolute;
  top: 0;
  left: 0;
`;

export default DateButton;
